import { createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../_helpers/_methods';

export const initialState = {
  loading: false,
  rosters: [],
  totalCount: 0
};

// A slice
const rostersSlice = createSlice({
  name: 'rosters',
  initialState,
  reducers: {
    getRosters: (state, action) => {
      state.rosters = action.payload.rosters;
      state.totalCount = action.payload.totalCount;
    },
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    }
  }
});

// Actions generated from the slice
const { getRosters, startLoading, stopLoading } = rostersSlice.actions;

// export user selector to get the slice in any component
export const rostersSelector = (state) => state.rosters;

// export The reducer
const rostersReducer = rostersSlice.reducer;

export default rostersReducer;

// Actions

export const fetchRosters = (url) => async (dispatch) => {
  try {
    dispatch(startLoading());
    const response = await fetchWrapper.get(url);
    dispatch(getRosters({ rosters: response.data.results, totalCount: response.data.count }));
    dispatch(stopLoading());
  } catch (error) {
    dispatch(stopLoading());
    console.log(error);
    ErrorMessageHandler(error);
  }
};
export const fetchRoster = (url) => async (dispatch) => {
  try {
    dispatch(startLoading());
    const response = await fetchWrapper.get(url);
    dispatch(getRosters({ rosters: response.data, totalCount: response.data.count }));
    dispatch(stopLoading());
  } catch (error) {
    dispatch(stopLoading());
    console.log(error);
    ErrorMessageHandler(error);
  }
};
